import { CHANGE_VIEW } from '../../actions/chart';
import { CHART_VIEW } from '../../../utils/constants';

export default (state = CHART_VIEW.CARDS, action) => {
  switch(action.type) {
    case CHANGE_VIEW:
      return action.payload.view;
    default:
      return state;
  }
};

export const getView = state => state;